import React from "react";

function capitalize(str: string) {
  if (typeof str !== "string") {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const StepIndicator = ({
  currentStep,
  steps,
  setCurrentStep,
}: {
  currentStep: string;
  steps: string[];
  setCurrentStep: (step: string) => void;
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex justify-between my-4 px-8 items-center">
        {steps.map((step, index) => {
          const isCurrent = step.toLowerCase() === currentStep;
          const hasCompleted = steps.indexOf(step) < steps.indexOf(currentStep);

          let fill;
          if (isCurrent) {
            fill = "border-green-500 border-4";
          } else if (hasCompleted) {
            fill = "bg-green-500 border-4 border-green-500 cursor-pointer";
          } else {
            fill = "bg-gray-300 border-4 border-gray-300";
          }

          return (
            <React.Fragment key={step}>
              <div
                className="flex items-center flex-col"
                onClick={() => (hasCompleted ? setCurrentStep(step) : null)}
              >
                <div
                  className={`h-4 w-4 rounded-full transition-all duration-500 ${fill}`}
                />
                <span className="text-sm mt-1 font-bold">
                  {capitalize(step)}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`flex-auto h-4 border-t-2 -mt-2 transition-all duration-500  ${
                    hasCompleted ? "border-green-300" : "border-gray-300"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
